module.exports = __webpack_public_path__ + "img/1_鸟瞰哈尔滨国际会展中心2(1).5831de59.jpg";